(function(){
    'use strict';

    angular.module('UndergroundWebApp').factory('containerItemService', containerItemService);

    containerItemService.$inject =['$q', '$http'];

    function containerItemService($q, $http){
        var service = {
            getContainerItems: getContainerItems,
            addContainerItem: addContainerItem,
            updateContainerItem: updateContainerItem,
            deleteContainerItem: deleteContainerItem
        };

        function getContainerItems(containerId) {
            var deferred = $q.defer();
            $http.get('api/containersv2/' + containerId + '/items').then(function (result) {
                if (result && result.data) {
                    deferred.resolve(result.data);
                }
                else {
                    deferred.reject();
                }
            }, function () {
                deferred.reject();
            });

            return deferred.promise;
        }

        function addContainerItem(containerItem) {
            var deferred = $q.defer();
            $http.post('api/containersv2/items', containerItem).then(function (result) {
                if (result && result.data) {
                    deferred.resolve(result.data);
                }
                else {
                    deferred.reject();
                }
            }, function () {
                deferred.reject();
            });

            return deferred.promise;
        }

        function updateContainerItem(containerItem) {
            var deferred = $q.defer();
            $http.put('api/containersv2/items', containerItem).then(function (result) {
                if (result && result.data) {
                    deferred.resolve(result.data);
                }
                else {
                    deferred.reject();
                }
            }, function () {
                deferred.reject();
            });

            return deferred.promise;
        }

         function deleteContainerItem(containerItemId) {
            var deferred = $q.defer();
            $http.delete('api/containersv2/items/' + containerItemId).then(function (result) {
                if (result && result.data) {
                    deferred.resolve(result.data);
                }
                else {
                    deferred.reject();
                }
            }, function () {
                deferred.reject();
            });

            return deferred.promise;
        }

        return service;
    }
})();
